/**
 * PosPage — Punto de venta externo: locales, terminales, folios, ventas, operadores, POS Clobi y Clobi Conector.
 *
 * No confundir con la venta de mostrador desde la web (`sales.pos`, #1259): esto
 * administra los equipos del POS que emiten con su propia credencial.
 */
import { Outlet, useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/HelpPanel'
import { HELP } from '@/data/helpContent'

const PAGE_META: Record<string, { title: string; subtitle: string; helpKey: string }> = {
  stores: {
    title: 'Locales',
    subtitle: 'Dónde están las cajas y de qué bodega sale lo que venden.',
    helpKey: 'pos.stores',
  },
  terminals: {
    title: 'Terminales',
    subtitle: 'Los equipos del punto de venta: activación, revocación y último contacto.',
    helpKey: 'pos.terminals',
  },
  folios: {
    title: 'Folios de terminales',
    subtitle: 'Los rangos que cada caja usa para emitir sin conexión.',
    helpKey: 'pos.folios',
  },
  cash: {
    title: 'Cajas',
    subtitle: 'El arqueo de cada caja y si su cierre ya está en la contabilidad.',
    helpKey: 'pos.cash',
  },
  operators: {
    title: 'Operadores',
    subtitle: 'Quiénes operan las cajas, en qué locales y con qué PIN.',
    helpKey: 'pos.operators',
  },
  rules: {
    title: 'POS Clobi',
    subtitle: 'La aplicación de punto de venta: instalador, manual y las reglas que valen para todas las cajas.',
    helpKey: 'pos.rules',
  },
  agent: {
    title: 'Clobi Conector',
    subtitle: 'Cómo leen e imprimen los equipos que reciben los documentos del sistema de gestión.',
    helpKey: 'pos.agent',
  },
  sales: {
    title: 'Ventas de los terminales',
    subtitle: 'Las boletas que imprimieron las cajas y qué pasó con cada una ante el SII.',
    helpKey: 'pos.sales',
  },
}

export default function PosPage() {
  const { pathname } = useLocation()
  const meta = PAGE_META[pathname.split('/').pop() || 'stores'] || PAGE_META.stores

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <PageHeader title={meta.title} subtitle={meta.subtitle} help={HELP[meta.helpKey]} />
      <Outlet />
    </div>
  )
}
